import { AlertType, useAlerts } from "best-common-react";
import React, { ReactNode, useContext } from "react";

type SiteSiteAlertContextType = {
  /**
   * @deprecated This function is deprecated in favor of addAlert from best-common-react
   */
  addAlert: (alert: AlertType) => void;
  /**
   * @deprecated This function is deprecated in favor of removeAlert from best-common-react
   */
  removeAlert: (id: string) => void;
};

const SiteSiteAlertContext = React.createContext<SiteSiteAlertContextType | undefined>(undefined);

const SiteAlertProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { addAlert, removeAlert } = useAlerts();

  return <SiteSiteAlertContext.Provider value={{ addAlert, removeAlert }}>{children}</SiteSiteAlertContext.Provider>;
};

/**
 * @deprecated This hook is deprecated in favor of useAlerts from best-common-react
 */
const useSiteAlerts = (): SiteSiteAlertContextType => {
  const context: SiteSiteAlertContextType | undefined = useContext(SiteSiteAlertContext);
  if (context === undefined) {
    throw new Error(`useSiteAlerts must be used within a SiteAlertProvider`);
  }
  return context;
};

export { SiteAlertProvider, useSiteAlerts };
